var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymce-editor"},[_c('textarea',{attrs:{"id":_vm.id}}),_vm._v(" "),_c('q-inner-loading',{attrs:{"showing":_vm.store.isUploadingImage}},[_c('q-spinner-dots',{attrs:{"size":"md"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }